import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';
import { useAtomValue, useSetAtom } from 'jotai';
import { bulkProvisioningFiltersAtom } from 'atoms/filters/bulk-provisioning.ts';
import {
  mapBulkProvisioningFiltersToURLSearchParams,
  mapURLSearchParamsToBulkProvisioningFilers,
} from '../utils/filtersToURLSearchParamsMapper.ts';

export const BulkProvisioningFiltersURLParser = ({
  children,
}: {
  children: React.ReactElement;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const setFilters = useSetAtom(bulkProvisioningFiltersAtom);
  const isMounted = useRef(false);

  const filters = useAtomValue(bulkProvisioningFiltersAtom);

  useEffect(() => {
    if (isMounted) {
      setSearchParams(mapBulkProvisioningFiltersToURLSearchParams(filters), { replace: true });
    }
  }, [filters]);

  if (!isMounted.current) {
    setFilters(mapURLSearchParamsToBulkProvisioningFilers(searchParams));
    isMounted.current = true;
  }

  return <>{children}</>;
};
